<script>
  import TextIcon from "./TextIcon.vue";
  import AtomStatusPill from "../atoms/AtomStatusPill.vue";
  import UserTag from "./UserTag.vue";

  export default {
    name: "userNameTimestamp",

    components: { TextIcon, AtomStatusPill, UserTag },

    props: {
      userName: { type: String },
      label: { type: String },
      showPill: { type: Boolean },
      user: { type: Object, defaul: () => ({}) },
    },
  };
</script>

<template>
  <div class="userNameTimestamp">
    <TextIcon :label="userName" class="userNameTimestamp__username" :styles="{ label: { fontSize: '16px' }, icon: { fontSize: '18px' } }" icon="newUserIcon">
      <AtomStatusPill v-if="showPill" label="Actual" variant="success" />
    </TextIcon>

    <TextIcon class="userNameTimestamp__date" v-if="label" :label="label" icon="calendarDisabled" :styles="{ icon: { fontSize: '18px' } }">
      <UserTag
        class="userNameTimestamp__avatar"
        :avatarStyles="{ width: '20px' }"
        :showOnlyAvatar="true"
        :canShowTooltip="true"
        :key="user?._id"
        :user="user || {}"
        tooltipModifier="left"
        tooltipVariant="down"
        modifier="card"
        v-if="user?._id"
      />
    </TextIcon>
  </div>
</template>

<style lang="scss">
  .userNameTimestamp {
    @include Flex(column, center, flex-start);
    flex-direction: column;
    gap: 12px;
    padding: 16px 14px;
    border-radius: 8px;
    background: #fff;

    &__username {
      color: #212121;
      font-family: $newFont_medium;
      font-size: 16px;
      font-weight: 500;
      .userNameTimestamp__label {
        font-size: 16px;
      }
    }

    &__date {
      font-family: $newFont_regular;
      color: #434343;
      font-size: 14px;
    }

    &__avatar {
      outline: solid 1px $primary-color;
      min-width: 20px;
      height: 20px;
      padding: 0px;
      background: none;

      .tooltipContainer--down {
        top: -35px;
      }
    }
  }
</style>
